export default __webpack_public_path__ + "static/media/native.06bd2496.png";